<template>
    <div class="main-content row justify-content-center">
        <div class="col-md-10 px-0 text-left">
            <h4 class="text-normal" v-html="houseMap.house_title"></h4>
            <div class="details-content">
                <img :src="houseMap.main_photo" v-if="houseMap.main_photo" :alt="houseMap.house_title" class="img-fluid my-3 main-photo">
                <Skeleton v-else />
                <div class="desc-text" v-if="houseMap.content" v-html="houseMap.content && houseMap.content.rendered"></div>
                <Skeleton v-else />
                <hr />
                <div class="row">
                    <div class="col-md-3 font-bold mb-2" v-if="houseMap.content">
                        Estate Features
                    </div>
                    <Skeletal v-else />
                    <div class="row col-md-9" v-if="houseMap.main_features">
                        <div class="col-md-4 mb-md-2" 
                        v-for="(feature, index) in houseMap.main_features.split('\n').filter((item, index) => item.trim())"
                        :key="index" v-html="feature"></div>
                    </div>
                    <div class="row" v-else>
                        <div class="col-md-4 mb-md-2" v-repeat="[1,2,3]">
                            <Skeletal />
                        </div>
                    </div>
                </div>
                <hr />
                <div class="row px-2 justify-content-center">
                    <div class="feature-column col" v-if="houseMap.features_a">
                        <span class="d-block" v-for="(item, index) in houseMap.features_a.split('\n')"
                        :key="index" v-html="item"></span>
                    </div>
                    <Skeleton v-else />
                    <div class="feature-column col" v-if="houseMap.features_b">
                        <span class="d-block" v-for="(item, index) in houseMap.features_b.split('\n')"
                        :key="index" v-html="item"></span>
                    </div>
                    <Skeleton v-else />
                    <div class="feature-column col" v-if="houseMap.features_c">
                        <span class="d-block" v-for="(item, index) in houseMap.features_c.split('\n')"
                        :key="index" v-html="item"></span>
                    </div>
                    <Skeleton v-else />
                    <div class="feature-column col" v-if="houseMap.features_d">
                        <span class="d-block" v-for="(item, index) in houseMap.features_d.split('\n')"
                        :key="index" v-html="item"></span>
                    </div>
                    <div class="feature-column col" v-if="houseMap.features_e">
                        <span class="d-block" v-for="(item, index) in houseMap.features_e.split('\n')"
                        :key="index" v-html="item"></span>
                    </div>
                </div>
                <hr />
                <div class="row" v-if="houseMap.additional_photos">
                    <div class="col-md-4" v-for="(photo, index) in houseMap.additional_photos.split('\n')"
                        :key="index">
                        <img :src="photo" :alt="houseMap.house_title" class="img-fluid image-additional">
                    </div>
                </div>
                <div class="row" v-else>
                    <div class="col-md-4" v-repeat="[1,2,3]">
                        <Skeletal />
                    </div>
                </div>
            </div>
            <div class="row justify-content-center mt-2 mt-md-5" v-if="houseMap.download_link">
                <a :href="houseMap.download_link" 
                target="_blank" rel="noopener noreferrer"
                class="btn-default-style bg-default-color make-reserve-btn">
                    Make Reservation
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import { Skeleton } from 'vue-loading-skeleton'

export default {
    name: 'OurHousesDetails',
    components: {
        Skeleton
    },
    metaInfo() {
        return {
            title: this.houseMap && this.houseMap.title ? 
            this.houseMap.title.rendered : 'Houses',
            description: this.houseMap.content && this.houseMap.content.rendered ?
            this.houseMap.content.rendered : 
            'Revolution Plus Property Limited. The most trusted and reliable Real Estate Company in Nigeria. Buy Land in Ibeju Lekki. Buy Property at Sangotedo'
        }
    },
    computed: {
        houses() {
            return this.$store.state.houses
        },
        houseMap() {
            return this.$store.state.currentHouse
        }
    },
}
</script>

<style scoped>
.main-content {
    padding: 15px;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    border-radius: 7px;
}
.main-photo {
    min-height: 100px
}
@media (min-width: 992px) {
    .main-content {
        padding: 50px;
        border-radius: 15px;
    }
}
.details-content {
    box-shadow: 10px 10px 6px #0000000D;
    padding: 20px;
    border: 1px solid #e6e6e6;
    border-radius: 12px;
}
.make-reserve-btn,
.make-reserve-btn:hover {
    border-radius: 10px;
    text-decoration: none;
    text-align: center
}
@media (max-width: 768px) {
    .make-reserve-btn {
        margin-top: 10px;
    }
}
.feature-column {
    font-size: 11px;
    padding-right: 6px;
    padding-left: 6px;
}
.image-additional {
    position: relative;
    right: 3px;
}
@media (max-width: 992px) {
    .feature-column {
        font-size: 13px;
        flex: 0 0 33%;
        max-width: 33%;
        margin-bottom: 7px;
    }
}
@media (max-width: 768px) {
    .feature-column {
        flex: 0 0 100%;
        max-width: 100%;
    }
}
@media (min-width:1200px) {
    .feature-column {
        flex: 0 0 20%;
        max-width: 20%;
    }   
}
.desc-text >>> p {
    margin-bottom: 5px;
}
.image-additional {
    height: auto;
    min-height: 100px;
}
</style>